import { BaseViewStore } from 'core/stores';
import { action, observable, makeObservable } from 'mobx';
import _ from 'lodash';

class ReceivingExpandListViewStore extends BaseViewStore {
	@observable change = false;
	data = [];
	noDataItem = true;

	constructor(rootStore, { dataItem }) {
		super(rootStore);
		makeObservable(this);
		this.tableData = {
			columns: [
				{
					key: 'product.mainSku',
					title: 'RECEIVINGVIEW.SKU',
					selected: true,
					width: 200,
					filter: null,
					canFilter: false,
					resizable: false,
					sortable: false,
				},
				{
					key: 'quantity',
					title: 'RECEIVINGVIEW.QUANTITY',
					selected: true,
					width: 200,
					filter: null,
					canFilter: false,
					resizable: false,
					sortable: false,
				},
			],
			sortObject: [],
			actions: {},
			permissions: {},
			routes: {},
		};
		if (dataItem.isAutomated) {
			this.tableData.columns.push(
				{
					key: 'palletCount',
					title: 'RECEIVINGVIEW.PALLETQUANTITY',
					selected: true,
					width: 200,
					filter: null,
					canFilter: false,
					resizable: false,
					sortable: false,
				},
				{
					key: 'cost',
					title: 'RECEIVINGVIEW.PRICEPERSKU',
					selected: true,
					width: 200,
					filter: null,
					canFilter: false,
					resizable: false,
					sortable: false,
				}
			);
		} else {
			this.tableData.columns.push({
				key: 'description',
				title: 'RECEIVINGVIEW.DESCRIPTION',
				selected: true,
				width: 200,
				filter: null,
				canFilter: false,
				resizable: false,
				sortable: false,
			});
		}
		this.getReceivingProducts(dataItem);
	}

	@action.bound
	setAsChanged = () => {
		this.change = !this.change;
	};

	@action.bound
	getReceivingProducts = async dataItem => {
		this.suspend();
		this.data = dataItem.receivingProducts.slice();
		this.setAsChanged();
		this.resume();
	};

	openProductDetailPage = id => {
		this.rootStore.routerStore.goTo('master.app.main.product.list.detail', {
			id: id,
		});
	};
}

export default ReceivingExpandListViewStore;



// WEBPACK FOOTER //
// ./src/modules/receiving/stores/ReceivingExpandListViewStore.js